module.exports = __webpack_public_path__ + "static/media/bg-wave.c4f69f00.png";